import { BrowserModule } from '@angular/platform-browser';
import { isDevMode, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppStoreModule } from './store/store.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProgressSpinnerModule } from './progress-spinner/progress-spinner.module';
import { ProjectDuplicateModalModule } from './shared/dialogs/project-duplicate-modal/project-duplicate-modal.module';
import { SentryModule } from './shared/services/sentry/sentry.module';
import { AuthModule as Auth0Module, AuthHttpInterceptor } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { MAT_LEGACY_SNACK_BAR_DEFAULT_OPTIONS as MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/legacy-snack-bar';
import { BlobErrorHttpInterceptor } from './shared/interceptors/blob-error-http.interceptor';
import { MarkdownModule } from 'ngx-markdown';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { ServiceWorkerModule } from '@angular/service-worker';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    AppStoreModule,
    BrowserAnimationsModule,
    ProgressSpinnerModule,
    ProjectDuplicateModalModule,
    SentryModule,
    MarkdownModule.forRoot(),
    Auth0Module.forRoot({
      domain: environment.auth0Config.domain,
      clientId: environment.auth0Config.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
      },
      cacheLocation: 'memory',
      // STUDIO-638 https://auth0.com/docs/api-auth/token-renewal-in-safari
      useRefreshTokens: true,
      // guaranteed backwards compatibilty with existing actions https://t.ly/1AzOm
      useFormData: false,
      // Urls Auth0 should attach auth tokens to
      httpInterceptor: {
        allowedList: [
          `${environment.apiConfig.url}/*`,
          `${environment.analytics.url}/*`,
          {
            uriMatcher: (uri) =>
              !uri.includes('organization-invitation/accept') &&
              !uri.includes('resend-verify-email') &&
              (uri.startsWith(environment.apiOrg.url) || uri.startsWith(environment.apiOrg.urlV2)),
          },
        ],
      },
      errorPath: 'auth-error',
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    ...(environment.gtmId
      ? [
          GoogleTagManagerModule.forRoot({
            id: environment.gtmId,
          }),
        ]
      : null),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BlobErrorHttpInterceptor, multi: true },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2000 } },
    // AnalyticsBrowser is not marked @Injectable as it is not Angular specific
    // so add it here to make it injectable
    AnalyticsBrowser,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
